// edEx brand palette — aligned with logo (red "ed", blue "Ex")
export const theme = {
  brandBlue: '#1565C8',
  brandRed: '#D32F2F',
  navy: '#0F172A',
  slate: '#64748B',
  canvas: '#F1F5F9',
  surface: '#FFFFFF',
  surfaceAlt: '#F8FAFC',
  border: '#E2E8F0',
  leaderRow: '#EFF6FF',
  underPar: '#059669',
  evenPar: '#0F172A',
  overPar: '#D32F2F',
  shadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
  radius: 12,
  fontSm: 16,
  fontMd: 17,
  fontBase: 18,
};

export const ewtModalClass = 'ewtModal';

export const modalStyle = { top: 10 };

export const tableCellHeader = {
  backgroundColor: theme.navy,
  border: 'none',
  padding: '6px 4px',
  fontSize: 18,
  fontWeight: 600,
  color: '#FFFFFF',
  textAlign: 'center',
  letterSpacing: '0.02em',
};

export function scoreColor(value) {
  if (value == null || value === '') return theme.evenPar;
  if (value < 0) return theme.brandRed;
  return theme.evenPar;
}

/** Round player handicap for net scoring (.5+ up, .4- down). */
export function roundHandicapForScoring(handicap) {
  if (handicap == null || handicap === '') return 0;
  const n = parseFloat(handicap);
  if (isNaN(n)) return 0;
  return Math.round(n);
}

/** Display stored player handicap, preserving fractional part when present. */
export function formatPlayerHandicap(handicap) {
  if (handicap == null || handicap === '') return '';
  const n = parseFloat(handicap);
  if (isNaN(n)) return String(handicap);
  const rounded = Math.round(n * 10) / 10;
  if (Number.isInteger(rounded)) return String(rounded);
  return rounded.toFixed(1);
}
